import styled from 'styled-components';

export const Container = styled.button`
  background: transparent !important;
  border-radius: 100px;
  border: 1px solid #004f92;

  width: 250px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0px;
  cursor: pointer;
  color: #004f92;
`;
